












import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

import AnalyticsCardList, {
  AnalyticsCardListItem
} from '@/componentsV2/organisms/AnalyticsCardList/AnalyticsCardList.vue';

import PerformanceActivitiesService from '@/api/PerformanceActivitiesService';

@Component({
  components: {
    AnalyticsCardList
  }
})
export default class ActivitiesOverviewReferralProgram extends Vue {
  @Prop() filters!: Record<string, any>;
  @Prop({ default: true }) showRequestLoading?: boolean;

  performanceActivitiesService: PerformanceActivitiesService = new PerformanceActivitiesService();

  analytics: Record<string, AnalyticsCardListItem> = {
    totalReferrals: {
      hidden: true,
      infos: {
        title: 'Total referrals',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    },
    newCustomers: {
      infos: {
        title: 'New members',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    },
    customersPurchases: {
      infos: {
        title: 'Members purchases',
        amount: 0,
        tooltipText: '',
        insightText: '',
        counterFractionDigits: 0
      }
    }
  };

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get tPrefix() {
    return `performance.activities.campaignActivity.tabs.referralProgram`;
  }

  get translatedAnalytics() {
    return Object.entries(this.analytics)
      .map(([key, value]) => ({
        ...value,
        infos: {
          ...value.infos,
          tooltipText: this.$t(`${this.tPrefix}.${key}.tooltip`)
        }
      }))
      .filter(({ hidden }) => !hidden);
  }

  @Watch('filters')
  async getOverview() {
    if (this.showRequestLoading) {
      this.$showLoaderWithLocker();
    }

    let endpointPath = `/v2/admin/business-referral/reports`;

    const response = await this.performanceActivitiesService.getActivitiesOverview(
      endpointPath,
      this.filters
    );

    this.$hideLoader();

    if (response.status !== 200) return;

    const {
      totalReferral,
      newCustomers,
      firstRevenue,
      customersPurchase,
      totalRevenue
    } = response.data;

    this.analytics.totalReferrals.infos.amount = totalReferral;
    this.analytics.newCustomers.infos.amount = newCustomers;
    this.analytics.customersPurchases.infos.amount = customersPurchase;
  }

  mounted() {
    setTimeout(() => this.getOverview(), 0);
  }
}
